import { MouseSelectionContext } from '../contexts/MouseSelectionContext'
import { useMouseSelectionTracker } from '../hooks/useMouseSelection'

interface MouseSelectionProviderProps {
  children: React.ReactNode
}

/**
 * Keeps one DocumentSelectionChanged subscription for the whole add-in lifetime.
 * ContextBar unmounts on route change - without this, Word Online hosts can stop
 * delivering selection events after repeated add/removeHandlerAsync cycles.
 */
export const MouseSelectionProvider = ({ children }: MouseSelectionProviderProps) => {
  const value = useMouseSelectionTracker()

  return <MouseSelectionContext value={value}>{children}</MouseSelectionContext>
}
